import { tutorsConstants } from './constants';

const INITIAL_STATE = { 
    tutorCourses: [], 

 };


export function tutors(state = INITIAL_STATE, action) {

   switch (action.type) {
            
    case tutorsConstants.SHOW_TUTOR_COURSES:
    return {
        ...state,
        tutorCourses: action.tutorCourses
        };  

    default:
      return state
  }
}

